/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Report API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  BusinessReportExportResponse,
  DashboardReportExportResponse,
  FilterResponse,
  GetV8ReportExportBusinessParams,
  GetV8ReportExportDashboardParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getBusinessReportExports
 */
export const getV8ReportExportBusiness = (
  params: MaybeRef<GetV8ReportExportBusinessParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<BusinessReportExportResponse>(
    { url: `/api/v8/report/export/business`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ReportExportBusinessQueryKey = (
  params?: MaybeRef<GetV8ReportExportBusinessParams>,
) => {
  return ['api', 'v8', 'report', 'export', 'business', ...(params ? [params] : [])] as const;
};

export const getGetV8ReportExportBusinessQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ReportExportBusiness>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ReportExportBusinessParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ReportExportBusiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ReportExportBusinessQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ReportExportBusiness>>> = ({
    signal,
  }) => getV8ReportExportBusiness(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ReportExportBusiness>>,
    TError,
    TData
  >;
};

export type GetV8ReportExportBusinessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ReportExportBusiness>>
>;
export type GetV8ReportExportBusinessQueryError = ErrorType<unknown>;

/**
 * @summary getBusinessReportExports
 */

export function useGetV8ReportExportBusiness<
  TData = Awaited<ReturnType<typeof getV8ReportExportBusiness>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ReportExportBusinessParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ReportExportBusiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ReportExportBusinessQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getDashboardReportExports
 */
export const getV8ReportExportDashboard = (
  params?: MaybeRef<GetV8ReportExportDashboardParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<DashboardReportExportResponse>(
    { url: `/api/v8/report/export/dashboard`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ReportExportDashboardQueryKey = (
  params?: MaybeRef<GetV8ReportExportDashboardParams>,
) => {
  return ['api', 'v8', 'report', 'export', 'dashboard', ...(params ? [params] : [])] as const;
};

export const getGetV8ReportExportDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ReportExportDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8ReportExportDashboardParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ReportExportDashboard>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ReportExportDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ReportExportDashboard>>> = ({
    signal,
  }) => getV8ReportExportDashboard(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ReportExportDashboard>>,
    TError,
    TData
  >;
};

export type GetV8ReportExportDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ReportExportDashboard>>
>;
export type GetV8ReportExportDashboardQueryError = ErrorType<unknown>;

/**
 * @summary getDashboardReportExports
 */

export function useGetV8ReportExportDashboard<
  TData = Awaited<ReturnType<typeof getV8ReportExportDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8ReportExportDashboardParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ReportExportDashboard>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ReportExportDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getReportFilter
 */
export const getV8ReportExportFilter = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<FilterResponse>(
    { url: `/api/v8/report/export/filter`, method: 'GET', signal },
    options,
  );
};

export const getGetV8ReportExportFilterQueryKey = () => {
  return ['api', 'v8', 'report', 'export', 'filter'] as const;
};

export const getGetV8ReportExportFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ReportExportFilter>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8ReportExportFilter>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ReportExportFilterQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ReportExportFilter>>> = ({
    signal,
  }) => getV8ReportExportFilter(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ReportExportFilter>>,
    TError,
    TData
  >;
};

export type GetV8ReportExportFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ReportExportFilter>>
>;
export type GetV8ReportExportFilterQueryError = ErrorType<unknown>;

/**
 * @summary getReportFilter
 */

export function useGetV8ReportExportFilter<
  TData = Awaited<ReturnType<typeof getV8ReportExportFilter>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ReportExportFilter>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ReportExportFilterQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
